import { UploadFileControl, UploadFileModel } from '@portal/upload-file/data-access';
import { Exclude, Expose, Type } from 'class-transformer';
import {
  BaseModel,
  CrsTaxResidenceModel,
  DATEPICKER,
  PersonnelAppointment,
  PersonnelGender,
  PersonnelMarital,
  PersonnelRace,
  PersonnelRelationship,
  PersonnelResidency,
  UniqueArray,
  ToStartOfLocalDateString,
} from '@core/data-access';
import { PersonnelAddressModel } from './personnel-address.model';
import { PersonnelContactModel } from './personnel.model';
import { Default } from '@core/util';

@Exclude()
export class AboutYouModel extends PersonnelContactModel {
  @Expose() id!: number;

  @Expose() name!: string;

  @Expose() nricNumber!: string;

  @Expose() @Default([]) @UniqueArray() appointment!: PersonnelAppointment[];

  @Expose() nationalityId!: number;

  @Expose() residentialStatus!: PersonnelResidency | null;

  @Expose()
  @Default(null)
  dateOfBirth!: string | null;

  @Expose()
  @ToStartOfLocalDateString(DATEPICKER.PATTERN)
  @Default(null)
  dateOfBirthOnly!: string | null;

  @Expose() placeOfBirthCountryId!: number;

  @Expose() gender!: PersonnelGender;

  @Expose() relationshipToApplicant!: PersonnelRelationship[];

  @Expose() relationshipToApplicantOther!: string;

  @Expose() race!: PersonnelRace;

  @Expose() raceOther!: string;

  @Expose() maritalStatus!: PersonnelMarital;

  @Expose() dualNationality!: boolean;

  @Expose() dualNationalityId!: number;

  @Expose({ toClassOnly: true })
  @Type(() => Map<string, UploadFileModel>)
  @Default(() => new Map<string, UploadFileModel>())
  cpfAttachments!: UploadFileControl;

  @Expose({ toClassOnly: true })
  @Type(() => Map<string, UploadFileModel>)
  @Default(() => new Map<string, UploadFileModel>())
  noaAttachments!: UploadFileControl;

  @Expose()
  @Type(() => PersonnelAddressModel)
  address!: PersonnelAddressModel;
}

@Exclude()
export class CreditReportRequestModel extends BaseModel {
  @Expose()
  creditReportRequest!: boolean;
}

@Exclude()
export class CommonReportingStandardModel extends BaseModel {
  @Expose()
  @Default([])
  crs!: CrsTaxResidenceModel[];
}

@Exclude()
export class FatcaModel extends BaseModel {
  @Expose() usPermanentResidentCardHolder!: boolean;
  @Expose() usPermanentResidentCardHolderTaxNumber!: string;
  @Expose() visa!: string;
}

export class ESignatureModel extends BaseModel {
  @Expose()
  @Type(() => Map<string, UploadFileModel>)
  @Default(() => new Map<string, UploadFileModel>())
  signature!: UploadFileControl;
}

@Exclude()
export class MarketingConsentModel extends BaseModel {
  @Expose() isEAdvice!: boolean;
  @Expose() isContactSMS!: boolean;
  @Expose() isFax!: boolean;
}
